import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useMemo } from 'react';
import { getProductPoints, hasUserEnoughPoints } from "../utils/internal";
import { jsx as _jsx } from "react/jsx-runtime";
export var productContext = /*#__PURE__*/createContext({
  code: '',
  hasEnoughPoints: false,
  image: '',
  name: '',
  price: {
    currentFormatted: '',
    old: ''
  },
  rating: 0,
  ratingCount: 0,
  url: ''
});
var Provider = productContext.Provider;
export var ProductProvider = function ProductProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  var code = value.code,
    remainingPoints = value.remainingPoints,
    shades = value.shades;
  var hasEnoughPoints = hasUserEnoughPoints({
    code: code,
    remainingPoints: remainingPoints,
    shades: shades
  });
  var productPoints = getProductPoints({
    code: code,
    shades: shades
  });
  return /*#__PURE__*/_jsx(Provider, {
    value: useMemo(function () {
      return _objectSpread({
        hasEnoughPoints: hasEnoughPoints,
        productPoints: productPoints
      }, value);
    }, [hasEnoughPoints, productPoints, value]),
    children: children
  });
};
//# sourceMappingURL=productContext.js.map